export const queryStrToNumArray = (param: string | string[]) => {
  return param
    ? param
        .toString()
        .split(",")
        .map((item) => +item)
    : null
}
